import React, { useRef, useState } from "react";
import Session from "../utils/sessionStorage";
import { ReactSVG } from "react-svg";
import arrow_back from "../assets/svgs/arrow_back.svg";
import dropdown_arrow from "../assets/svgs/Arrow.svg";
import history from "../assets/svgs/history.svg";
import { useNavigate } from "react-router-dom";
import { useClickOutside } from "../hooks/useClickOutside";

const getSessionArray = (key) => {
  try {
    const sessionValue = Session.get(key);
    const parsedValue = sessionValue ? JSON.parse(sessionValue) : [];

    return Array.isArray(parsedValue) ? parsedValue : [];
  } catch {
    return [];
  }
};

const Avatar = ({ userData, onMobileNoChange }) => {
  const result = Session.get("_user_");

  const data = userData || (result ? JSON.parse(result) : "");
  const avaNumbers = getSessionArray("avaNumbers");

  const saOrgName = data?.saOrgName;
  const [isMobileDropdownOpen, setIsMobileDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  useClickOutside(dropdownRef, () => setIsMobileDropdownOpen(false));

  const navigate = useNavigate();
  const mobileNumbers = Array.from(
    new Set([data?.mobileNo, ...avaNumbers].filter(Boolean))
  );

  const handleMobileNoSelect = (mobileNo) => {
    if (mobileNo === data?.mobileNo) {
      setIsMobileDropdownOpen(false);
      return;
    }

    const updatedUserData = {
      ...(data || {}),
      mobileNo,
    };

    Session.set("_user_", JSON.stringify(updatedUserData));
    onMobileNoChange?.(updatedUserData);
    setIsMobileDropdownOpen(false);
  };

  return (
    <div className="flex items-center py-5 max-mobile_lg:w-full border-b-[1px] border-black/10">
      <div className="min-w-0 ms-4 w-full  pr-2 flex items-center justify-between">
        <div className="flex items-center gap-1"
          onClick={() => {
            window.location.href = `https://uat.onepay.com.my/dl/${saOrgName}/?OpName=Close`;
          }}
        >
          <ReactSVG src={arrow_back} />

          <p className="text-[17px] text-primary whitespace-nowrap">
            Main
          </p>
        </div>
        <div className="-ml-5 max-w-40" >
          <p className=" text-[17px] font-semibold truncate text-center">
            {data?.fullName ? data?.fullName : "No Profile Data"}
          </p>
          <div className="relative" ref={dropdownRef}>
            <button
              type="button"
              className="mx-auto flex min-w-0 max-w-full items-center justify-center gap-1 text-gray text-[15px] font-semibold"
              aria-expanded={isMobileDropdownOpen}
              onClick={() => setIsMobileDropdownOpen((prev) => !prev)}
            >
              <span className="truncate">{data?.mobileNo}</span>
              <ReactSVG
                src={dropdown_arrow}
                className={`shrink-0 transition-transform ${
                  isMobileDropdownOpen ? "rotate-180" : ""
                }`}
              />
            </button>

            {isMobileDropdownOpen && (
              <div className="absolute left-1/2 top-full z-20 mt-2 w-[150px] -translate-x-1/2 overflow-hidden rounded-lg border border-black/10 bg-white shadow-lg">
                {mobileNumbers.map((mobileNo) => (
                  <button
                    key={mobileNo}
                    type="button"
                    className={`block w-full px-3 py-2 text-left text-[13px] font-semibold ${
                      mobileNo === data?.mobileNo
                        ? "bg-primary/10 text-primary"
                        : "text-gray"
                    }`}
                    onClick={() => handleMobileNoSelect(mobileNo)}
                  >
                    {mobileNo}
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>

        <div onClick={() => navigate("/history")}>
          <ReactSVG src={history} />
        </div>
      </div>
    </div>
  );
};

export default Avatar;
